import { useEffect } from 'react';

interface IUseCloseContextMenuOnScrollProps {
    bodySelector?: string;
    setOpen: (open: boolean) => void;
}

export const useCloseContextMenuOnScroll = ({
    setOpen,
    bodySelector = '.ag-body-viewport',
}: IUseCloseContextMenuOnScrollProps): void => {
    useEffect(() => {
        const agGridBody = document.querySelector(bodySelector);

        if (!agGridBody) {
            return undefined;
        }

        const handleScroll = () => setOpen(false);

        agGridBody.addEventListener('scroll', handleScroll);

        return () => {
            agGridBody.removeEventListener('scroll', handleScroll);
        };
    }, [bodySelector, setOpen]);
};
